import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderProduktinstruktionBaseCommand } from "./ArbetsorderProduktinstruktionBaseCommand";
export class DeleteArbetsorderProduktinstruktionCommand extends ArbetsorderProduktinstruktionBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteArbetsorderProduktinstruktionCommand";

    constructor(handelssortimentId: number, produktId: number, arbetsorderId: number, produktinstruktionId: number) {
        super(DeleteArbetsorderProduktinstruktionCommand.$type, CommandType.Delete);

        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.arbetsorderId = arbetsorderId;
        this.produktinstruktionId = produktinstruktionId;
    }
}
